import { SVGProps } from 'react'

import IconChevronDown from '@/assets/icons/chevron-down.svg'

interface Props extends SVGProps<SVGSVGElement> {
  isOpen: boolean
}

export default function InteractiveChevronIcon({ isOpen, ...props }: Props) {
  return (
    <IconChevronDown
      width={20}
      className={isOpen ? 'vertical-reversed' : ''}
      {...props}
      style={{
        transition: 'transform 0.2s ease-in-out',
        ...props.style,
      }}
    />
  )
}
